import {URLS} from "./app-urls";
import {AbstractService, Expands, Filters} from "./abstract-service";
import {RelatedCost} from "../models/basic/related-cost";
import {AxiosResponse} from "axios";
import {trackPromise} from "react-promise-tracker";
import Api from "./api-config";
import {ForecastProcessed, ReplenishmentSpareParts} from "../models/basic/replenishment";

export type ReplenishmentFilter = Filters & {
    years?: string,
    client_id?: string,
    client?: string,
    project?: string,
    ordering?: string,
};

export class ReplenishmentService extends AbstractService<ReplenishmentSpareParts> {

    constructor() {
        super(URLS.REPLANISHMENT_SPARE_PARTS);
    }

    override processFilters = (filters?: Filters) : Filters | undefined => {
        const processedFilter = {
            ...filters
        };

        if (processedFilter?.client_id === "0") {
            delete processedFilter.client_id;
        }

        if(processedFilter.years) {
            if(!processedFilter.years) {
                delete processedFilter.years;
            }
        }

        return processedFilter;
    }

    async listYears(): Promise<AxiosResponse<{ years: number[] }>> {
        const path = `${this.path}list_years/`;
        return await trackPromise(Api.get(path));
    }

    async replenishment_spare_parts(materials: string[] = []): Promise<AxiosResponse<ReplenishmentSpareParts[]>> {
        const path = `${this.path}`;
        let params = {}
        if (materials.length) {
            params = { materials: JSON.stringify(materials)};
        }
        return await trackPromise(Api.get<ReplenishmentSpareParts[]>(path, { params }));
    }

    async forecast(material_codes: string[] = []): Promise<AxiosResponse<any>> {
        const path = `api/forecast/forecast/`;
        const params = { material_codes: JSON.stringify(material_codes)};
        return await trackPromise(Api.get(path, { params }));
    }

    async forecast_download(material_codes: string): Promise<AxiosResponse<any>> {
        const path = `api/forecast/download/`;
        const params = { material_codes: material_codes};
        return await trackPromise(Api.get(path, { params, responseType: 'blob' }));
    }

    async forecast_processed(): Promise<AxiosResponse<ForecastProcessed>> {
        const path = `api/forecast/processed/`;
        return await trackPromise(Api.get(path));
    }

}
